import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux'
import { useCallback, useMemo } from 'react'
import type { RootState, AppDispatch } from './store'
import { getLocalStorageIsManager, getLocalStorageIsClientUser } from 'utils/utilityFunctions'

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useAppDispatch: () => AppDispatch = useDispatch
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector

export const usePermissions = () => {
	return  useAppSelector(state => state.auth.permissions);
}

export const useIsManager = (): boolean => {
	const isManager = useAppSelector(state => state.auth.is_manager)
	if (typeof isManager === 'boolean') {
	  return isManager
	}
	return getLocalStorageIsManager() || false
  }
export const useIsClientUser = (): boolean => {
  const isClientUser = useAppSelector(state => state.auth.is_clientUser)
  if (typeof isClientUser === 'boolean') {
    return isClientUser
  }
  return getLocalStorageIsClientUser() || false
  }
